import script from "./RepairView.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairView.vue?vue&type=script&setup=true&lang=js"

import "./RepairView.vue?vue&type=style&index=0&id=83a3cb60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a3cb60"]])

export default __exports__